import { Reveal } from "@components/ui";

const differentiators = [
  {
    title: "Smart Metering & Billing",
    desc: "Accurate readings, automated invoicing, and online payments.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M9 9h6M9 13h6M9 17h4" />
      </svg>
    ),
  },
  {
    title: "Dedicated Safety Team",
    desc: "Certified technicians on call 24/7.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    title: "Transparent Pricing",
    desc: "Clear tariffs with no hidden charges.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M15 8.5c-.685-.685-1.891-1-3-1-2.21 0-3.5 1.29-3.5 2.75S9.79 13 12 13s3.5 1.29 3.5 2.75-1.29 2.75-3.5 2.75c-1.109 0-2.315-.315-3-1M12 5.5v2M12 16.5v2" />
      </svg>
    ),
  },
  {
    title: "Regulatory Expertise",
    desc: "Full compliance with DCD, ESMA, FTA standards.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
        <path d="M14 2v6h6M9 15l2 2 4-4" />
      </svg>
    ),
  },
  {
    title: "Integrated Technology",
    desc: "Digital portal for billing, maintenance, and support.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <path d="M8 21h8M12 17v4" />
      </svg>
    ),
  },
];

export function AboutDifferentiatorsSection() {
  return (
    <section className="w-full py-16 md:py-20 lg:py-[100px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-10 md:gap-14">
        <Reveal direction="up">
          <div className="text-center max-w-[700px] mx-auto">
            <span className="text-[13px] md:text-[14px] font-semibold tracking-[0.1em] uppercase text-[#f24d2b]">
              Why GAZ
            </span>
            <h2 className="mt-3 text-[28px] md:text-[40px] lg:text-[54px] font-semibold tracking-[-0.04em] text-[#122d63]">
              What Makes Us Different
            </h2>
            <p className="mt-4 text-[16px] md:text-[20px] lg:text-[24px] tracking-[-0.04em] text-[#62636c]">
              We go beyond traditional gas services to deliver exceptional
              value and peace of mind.
            </p>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {differentiators.map((item, i) => (
            <Reveal key={i} direction="up" delay={i * 60}>
              <div className="h-full group rounded-[20px] bg-white border border-[#e9e8e6] p-7 md:p-8 flex flex-col gap-5 hover:border-[#f24d2b]/30 hover:shadow-[0_8px_30px_rgba(242,77,43,0.08)] transition-all duration-300">
                <div className="w-12 h-12 rounded-xl bg-[#f24d2b]/10 text-[#f24d2b] flex items-center justify-center group-hover:bg-[#f24d2b] group-hover:text-white transition-all duration-300">
                  {item.icon}
                </div>
                <div className="flex flex-col gap-2">
                  <h4 className="text-[18px] md:text-[22px] lg:text-[24px] font-semibold tracking-[-0.04em] text-[#090d2c] leading-[1.2]">
                    {item.title}
                  </h4>
                  <p className="text-[14px] md:text-[16px] lg:text-[18px] tracking-[-0.04em] text-[#62636c] leading-[1.6]">
                    {item.desc}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
